import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HeaderTagBase } from './../header-tagbase';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { ApiV6Service } from '@service/apiv6.service';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-edit-tagbase',
    templateUrl: './edit-tagbase.component.html',
    styleUrls: ['./edit-tagbase.component.scss'],
})
export class EditTagBaseComponent implements OnInit {
    public dataItem: HeaderTagBase;
    public resultResult: any[];

    @Input()
    public item: any;

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();

    constructor(
        private api: ApiV6Service,
        private translate: TranslateService,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService
    ) {
        this.menu.display = true;
        this.dataItem = new HeaderTagBase();
    }

    ngOnInit() {
        this.getResult(this.item.id);
        this.commonService.checkReset();
    }

    private async getResult(id) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('gettagbase', id ));
            this.resultResult = wRes.data.data;
            this.dataItem.Clear();
            if (id !== 0) {
                this.dataItem.load(this.resultResult[0]);
            }
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    delete(data) {
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data });
    }

    public async validate(data) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updatetagbase', data ));
            this.onValidate.emit({ index: this.item.index, id: this.item.id, data: wRes.data });
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
